import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../../../core/config/api-endpoints.constants';
import { createCatalogueStore } from '../../catalogue/catalogue-store.util';
import type { CatalogueStore } from '../../catalogue/catalogue.types';
import { Scope, ScopeCreate, ScopeUpdate } from '../models/scope.model';

@Injectable({ providedIn: 'root' })
export class ScopeStoreService implements CatalogueStore<Scope, ScopeCreate, ScopeUpdate> {
  private readonly store = createCatalogueStore<Scope, ScopeCreate, ScopeUpdate>({
    endpoint: API_ENDPOINTS.scopes,
    uploadPath: '/api/scopes/upload_image',
  });

  scopesResource = this.store.resource;
  items = this.store.items;
  loading = this.store.loading;
  error = this.store.error;
  byId = this.store.byId;
  reload = this.store.reload;
  create = this.store.create;
  update = this.store.update;
  remove = this.store.remove;
  uploadImage = this.store.uploadImage;
}
